import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorAccessAppointmentRegistrationList from './components/VisitorAccessAppointmentRegistrationList';

const { Cell } = ResponsiveGrid;

const VisitorAccessAppointmentRegistration = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客門禁預約及登記"
        // description="訪客列表"
        breadcrumbs={[
          {
            name: '訪客門禁',
          },
          {
            name: '訪客門禁預約及登記',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorAccessAppointmentRegistrationList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorAccessAppointmentRegistration;
